<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div class="row mb-3">
            <div class="col-12">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Start</th>
                            <th>Eind</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let period of periodList">
                            <td>{{period['name']}}</td>
                            <td>{{period['start_date']}}</td>
                            <td>{{period['end_date']}}</td>
                            <td>
                                <i class="bi bi-arrow-right-circle cursor-pointer p-3"
                                   (click)="select(period['id'])"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
